import { graphql } from 'gatsby';
import { createGatsbyPageComponent } from '@shapeable/ui';
export default createGatsbyPageComponent('Page');

export const QUERY = graphql`
query PageQuery($id: ID!) {
  platform { page(id: $id) {
    id name slug typeLabel badge path updated __typename _schema { label pluralLabel } 
    name 
    title 
    pretitle
    subtitle
    titleRich { text }
    subtitleRich { text }
    published
    themeMode { slug }
    bannerThemeMode { slug }
    content { text }
    options { text }
    openGraph { title description { plain } image { url url2x thumbnails { card { url url2x } bubble { url url2x } } } }
    intro { plain text }
    outro { text }
    orderNumber
    product {
      id name slug path __typename
      benefits {
        id name title description { text }
      }
      industryGroups {
        id name slug __typename
        openGraph {
          title description { plain }
          image { url url2x type }
        }
      }
    }
    layout {
      id name slug component 
    }
    videos {
      id name url
      thumbnail { id url url2x }
    }
    imageAssets {
      id name image { id url url2x type }
    }
    people {
      id name slug path
      organisation { id name }
      linkedin
      position
      photo { id url url2x type }
    }
    embeds {
      citations {
        slug url name authors { id name slug } authorShowsEtAl edition publication date accessDate startPage volume footnoteNumber year
      }
      pages {
        id name slug path
        openGraph {
          title description { plain }
          image { url url2x type }
        }
      }
      people {
        id name slug path
        organisation { id name }
        position
        photo { id url url2x }
      }
      imageAssets {
        id
        slug
        image {
          id url url2x type width height
        }
      }
    }
    parent {
      __typename id name path slug title subtitle pretitle 
      content { text }
      children {
        __typename id name path slug title subtitle pretitle 
        openGraph { description { text } }
        intro { text }
        orderNumber
        banner {
          name slug alternateText
          thumbnail { 
            id url url2x width height
          }
        }
      }
    }
    children {
      __typename id name path slug title subtitle pretitle 
      openGraph { description { text } }
      intro { text }
      orderNumber
      banner {
        name slug alternateText
        thumbnail { 
          id url url2x width height
        }
      }
    }
    banners {
      id name slug title description { text } alternateText
      image { 
        id url url2x type width height
      }
    }
    slices {
      id name slug 
      title
      disabled
      created updated
      outro { text }
      intro { text }
      titleRich { text }
      subtitleRich { text }
      themeMode { slug }
      images {
        id name slug alternateText description { text }
        image { 
          id url url2x type width height
        }
      }
      blocks {
        id name slug __typename
        pretitle
        title
        titleRich { text }
        subtitle
        link { id name slug label isDownload url page { path } type { id name } file { file { url } } }
        color { value }
        backgroundColor { value }
        page { id path name }
        links { id name slug label isDownload url page { path } type { id name } file { file { url } } }
        pages { id name }
        content { id text }
        options { id text }
        icon { openGraph { image { id type width height url } } }
        image { id name image { url url2x type } }
      }
      pages {
        id name path disabled
      }
      people {
        __typename
        id name slug 
        photo { url url2x type }
        position
        bio { text html(links: { target: "_blank" }) }
        linkedin
        organisation { id name }
      }
      products {
        id name slug path description { text }
        banner { image { id url url2x width height type } }
        links { id name slug label isDownload url page { path } type { id name } color { name} }
        industryGroups {
          id name slug
          openGraph {
            title description { plain }
            image { url url2x type }
          }
        } 
        backgroundColor { value }
        iconImage { image { id type width height url url2x } }
        color { value }
      }
      product {
        id name slug path __typename
        benefits {
          id name title description { text }
        }
        industryGroups {
          id name slug __typename
          openGraph {
            title description { plain }
            image { url url2x type }
          }
        }
      }
      links {
        id name url page { path }
      }
      options { text }
      files {
        id
        name
        slug
        file {
          id
          url
        }
        thumbnail {
          url url2x
        }
      }
      videos { 
        url 
        openGraph {
          image { url url2x type }
        }
      }
      color { value }
      backgroundColor { value }
      backgroundImages {
        image {
          url url2x
        }
      }
      blocks {
        id name slug 
        title 
        subtitle
        link { id url name }
        page { id path name }
        links { id name slug label isDownload url page { path } type { id name } file { file { url } } }
        pages { id name }
        content { text }
        options { text }
        image { id name image { url url2x type } }
      }
      content { text }
      image { id }
      layout { id name slug component }
      organisations {
        id
        name
        url
        organisationStatus { id name }
        logoInverted { type url url2x }
        logo { type url url2x }
        openGraph { image { id url url2x } }
      }
    }
  } }
}
`;
